<template>
  <AppContentPage class="catch-all-view"/>
</template>

<script setup lang="ts">
definePageMeta({
  // a content page with an empty group (/content-/<slug>/) lives in the root.
  // redirect in middleware, before the page loads: a navigateTo during setup
  // left the PageLoader without data and threw a fatal 500 on client navigation
  middleware: (to) => {
    if (to.path.startsWith('/content-/')) {
      const slug = to.path.split('/').filter(Boolean).pop()
      return navigateTo({ path: `/${slug}/`, query: to.query, hash: to.hash }, {
        redirectCode: 301,
        replace: true
      })
    }
  }
})
</script>
